import {
  PaymentPlanFailedChargeRecord,
  PaymentPlanMissedPaymentRecord,
  PaymentPlanPaymentRecord,
} from '@dill/dill-shared';

import { DillModal } from '../Dill/DillModal';
import { PaymentPlanHistoryList } from './PaymentPlanHistoryList';

export const PaymentPlanHistoryModal = ({
  open,
  onClose,
  paymentHistory,
  missedPayments,
  failedCharges,
  accountType = 'buyer',
}: {
  open: boolean;
  onClose: () => void;
  paymentHistory?: PaymentPlanPaymentRecord[] | null;
  missedPayments?: PaymentPlanMissedPaymentRecord[] | null;
  failedCharges?: PaymentPlanFailedChargeRecord[] | null;
  accountType?: 'supplier' | 'buyer';
}) => {
  return (
    <DillModal open={open} onClose={onClose} title="Payment History" maxWidth="720px">
      <PaymentPlanHistoryList
        paymentHistory={paymentHistory}
        missedPayments={missedPayments}
        failedCharges={failedCharges}
        accountType={accountType}
      />
    </DillModal>
  );
};

export default PaymentPlanHistoryModal;
